export default __webpack_public_path__ + "static/media/5.b7983fe2.jpg";